"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nativeEditors = nativeEditors;
const domain_core_1 = require("@standardnotes/domain-core");
const NoteType_1 = require("../Component/NoteType");
const NativeFeatureIdentifier_1 = require("../Feature/NativeFeatureIdentifier");
const PermissionName_1 = require("../Permission/PermissionName");
const ProductNames_1 = require("../Strings/ProductNames");
const ttag_1 = require("ttag");
function nativeEditors() {
    return [
        {
            name: ProductNames_1.SuperName,
            note_type: NoteType_1.NoteType.Super,
            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.SuperEditor,
            spellcheckControl: true,
            file_type: 'json',
            interchangeable: false,
            availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser],
            permission_name: PermissionName_1.PermissionName.SuperEditor,
            description: (0, ttag_1.c)('B7.FilesSubscriptionHelp.Subscription.Info')
                .t `The best way to edit notes. Type / to bring up the block selection menu, or @ to embed images or link other tags and notes. Type - then space to start a list, or [] then space to start a checklist. Drag and drop an image or file to embed it in your note. Cmd/Ctrl + F to bring up search and replace.`,
        },
        {
            name: (0, ttag_1.c)('B7.FilesSubscriptionHelp.Subscription.Info').t `Plain Text`,
            note_type: NoteType_1.NoteType.Plain,
            spellcheckControl: true,
            file_type: 'txt',
            interchangeable: true,
            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.PlainEditor,
            availableInRoles: [domain_core_1.RoleName.NAMES.CoreUser, domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser],
            permission_name: PermissionName_1.PermissionName.PlainEditor,
        },
    ];
}
